import { AuthenticationService } from "./authentication-service";

export abstract class AuthenticationBackendService extends AuthenticationService {

}
